import { observable }     from 'mobx';
import { makeObservable } from 'mobx';
import { action }         from 'mobx';
import { computed }       from 'mobx';
import React              from 'react';

type Route = {
	path: string;
	children?: Route[];
	[key: string]: any;
};

class BreadcrumbBarStore {
	@observable private _enabled = true;

	routes: Route[] = [];

	@observable private _rightComponent?: () => React.ReactNode;
	@observable private _breadcrumbSuffix?: string;

	constructor() {
		makeObservable(this);
	}

	@action setRightComponent(component?: () => React.ReactNode) {
		this._rightComponent = component;
	}

	@action setBreadcrumbSuffix(suffix?: string) {
		this._breadcrumbSuffix = suffix;
	}

	@action setEnabled(value: boolean) {
		this._enabled = value;
	}

	@computed get rightComponent() {
		return this._rightComponent;
	}

	@computed get breadcrumbSuffix() {
		return this._breadcrumbSuffix;
	}

	@computed get enabled() {
		return this._enabled;
	}

	setRoutes(routes: Route[]) {
		this.routes = routes;
	}
}

export default new BreadcrumbBarStore();
